import {yupResolver} from "@hookform/resolvers/yup";
import {FormProvider, useForm} from "react-hook-form";
import {
  createUserScheduleFormValidationSchema,
  CreateUserScheduleFormValues,
} from "./schema-validation";
import {UserScheduleNameFormField} from "./form-fields/schedule-name";
import {Button, Modal, Space} from "antd";
import {StyledModalContentWrapper} from "../../../../../../../components/calls/upcoming-calls/call-card/call-card.style";
import {useCreateUserScheduleHook} from "../../../hooks/create-user-schedule";
import {useCallback} from "react";
import {useUserScheduleContext} from "../../../context/user-schedule";

export function CreateScheduleFormModal() {
  const {
    dispatch,
    state: {isCreateUserScheduleModalOpen},
  } = useUserScheduleContext();
  const formMethods = useForm<CreateUserScheduleFormValues>({
    resolver: yupResolver(createUserScheduleFormValidationSchema),
    mode: "onChange",
    defaultValues: {},
  });

  const handleCloseCreateScheduleModal = useCallback(() => {
    dispatch({
      type: "toggle-create-user-schedule-modal",
      payload: false,
    });
  }, [dispatch]);

  const closeModal = useCallback(() => {
    formMethods.reset();
    handleCloseCreateScheduleModal();
  }, [formMethods, handleCloseCreateScheduleModal]);

  const {createUserSchedule, isCreatingUserSchedule} = useCreateUserScheduleHook({
    closeModal,
  });

  function onSubmit(values: CreateUserScheduleFormValues) {
    // console.log({values});
    createUserSchedule(values);
  }
  return (
    <Modal
      visible={isCreateUserScheduleModalOpen}
      title={"Create new schedule"}
      onOk={closeModal}
      onCancel={closeModal}
      footer={null}
      centered
    >
      <StyledModalContentWrapper>
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(onSubmit)} autoComplete="off">
            <Space size={16} direction="vertical" style={{display: "flex"}}>
              <UserScheduleNameFormField />
              <div style={{display: "flex", justifyContent: "end"}}>
                <Space size={16} direction="horizontal" style={{display: "flex"}}>
                  <Button size="small" onClick={handleCloseCreateScheduleModal}>
                    Cancel
                  </Button>
                  <Button
                    size="small"
                    type="primary"
                    htmlType="submit"
                    loading={isCreatingUserSchedule}
                  >
                    Create
                  </Button>
                </Space>
              </div>
            </Space>
          </form>
        </FormProvider>
      </StyledModalContentWrapper>
    </Modal>
  );
}
